import Tooltip from '@mui/material/Tooltip'
import { ReactNode, useState } from 'react'

type BCCategoryNameProps = {
  name: string
}

/** A category's name on one line, cut off with an ellipsis; hovering a cut-off name shows it whole. */
export function BCCategoryName({ name }: BCCategoryNameProps): ReactNode {
  const [isCutOff, setIsCutOff] = useState(false)

  return (
    <Tooltip title={isCutOff ? name : ''} placement="right" arrow>
      <span
        className="block min-w-0 max-w-full truncate px-2"
        onMouseEnter={(event) => setIsCutOff(event.currentTarget.scrollWidth > event.currentTarget.clientWidth)}
      >
        {name}
      </span>
    </Tooltip>
  )
}
